import { Component, OnInit } from '@angular/core';
import { SincronismoService } from '../../service/sincronismo.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { LoginService } from '../../service/login.service';
import * as FileSaver from 'file-saver';
import { MensagemService } from '../../service/mensagem.service';
import { Helper } from '../../shared/Helper';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Usuario } from 'src/app/model/Usuario';

@Component({
  selector: 'app-sincronismo',
  templateUrl: './sincronismo.component.html',
  styleUrls: ['./sincronismo.component.css']
})
export class SincronismoComponent implements OnInit {

  public arquivoCli: any;
  public arquivoProd: any;
  public arquivoCidEst: any;
  public percentDone: number;
  public enviando: boolean;
  public pedidos: any;
  public showRabge = false;
  public dataInicio: Date;
  public dataFim: Date;
  public nrPedido: string;
  public localizandoPedido: boolean;
  public startValue;
  public endValue;
  public clienteControl = new FormControl();
  public filteredOptions: any;
  public anosDisponiveis: number[];
  public anoCorrente: number;
  public mostraSincronismo: boolean = false;
  public historicoClienteCorrente: any = null;  
  public mostraTesteEmail: boolean = false;
  public carregandoConfiguracaoEmail: boolean = false;
  public enviandoTesteEmail: boolean = false;
  public configuracaoEmailErro: string = null;
  public testeEmail = {
    provedor: '',
    emailOrigem: 'contato@facinatus.net',
    emailDestino: '',
    assunto: '',
    mensagem: ''
  };

  constructor(private sincronismoService: SincronismoService, private loginService: LoginService, private msg: MensagemService,
    private router: Router) {
    this.anosDisponiveis = new Array<number>();
    var ac = (new Date()).getFullYear();
    this.anoCorrente = ac;
    for (let index = 2019; index <= ac; index++) {
      this.anosDisponiveis.push(index);
    }

    this.enviando = false;
    this.fillDataInicio();
  }

  public onAnoCorrenteSelectChange(e) {
    this.showRabge = false;
    var that = this;
    setTimeout(function () { that.fillDataInicio(); that.showRabge = true; }, 800);
  }

  private fillDataInicio() {

    if (this.anoCorrente == 0) {
      this.dataInicio = new Date(2019, 0, 1);
      this.dataFim = new Date();
      return;
    }
    var dt = new Date();

    this.startValue = new Date(this.anoCorrente - 1, 12, 1);
    this.endValue = new Date(this.anoCorrente, 11, 31);

    this.dataInicio = new Date(this.anoCorrente, dt.getMonth(), dt.getUTCDate());
    this.dataInicio.setDate(this.dataInicio.getDate() - 30);
    this.dataFim = new Date(this.anoCorrente, dt.getMonth(), dt.getUTCDate());
  }

  ngOnInit() {
    var papel = Helper.getPapelToken();
    this.mostraSincronismo = papel == "Gerente";
    this.loginService.Refresh();
    var that = this;
    setTimeout(function () { that.showRabge = true; }, 1000);
    try {

      this.clienteControl.valueChanges
        .pipe(
          debounceTime(400))
        .subscribe((value: string) => {
          this._filter(value);
        })
        ;
    }
    catch
    {

    }
  }

  private _filter(value: any): any {

    var filtro = "";
    if (value) {
      filtro = value.nome ? value.nome.toLowerCase() : value.toLowerCase();
    }
    if (filtro != "") {
      this.sincronismoService.Filtrar(filtro).subscribe(f => {
        this.filteredOptions = f;
      })
    }

  }

  public ClienteKeyUp(event) {
    if (event.key === "Enter") {
      this.findPeriodo();
    }
  }
  displayFn(cliente?: any): string | undefined {
    return cliente ? cliente.nome : undefined;
  }

  public findPedido() {
    this.localizandoPedido = true;
    this.sincronismoService.Pedidos(null, null, null, this.nrPedido).subscribe(p => {
      this.pedidos = p;
      if (this.pedidos) {
        this.pedidos.forEach(ped => {
          ped.nrPedido = this.pad(ped.nrPedido, 6);
        });
      }
      this.localizandoPedido = false;
    })
  }

  public findPeriodo() {
    var codCliente = null;
    if (this.clienteControl.value && this.clienteControl.value.nome) {
      codCliente = this.clienteControl.value.login;
      this.filteredOptions = new Array<Usuario>();
    }
    this.localizandoPedido = true;
    this.sincronismoService.Pedidos(this.dataInicio, this.dataFim, codCliente, null).subscribe(p => {
      this.pedidos = p;
      if (this.pedidos) {
        this.pedidos.forEach(ped => {
          ped.nrPedido = this.pad(ped.nrPedido, 6);
        });
      }
      this.localizandoPedido = false;
    })
  }

  public download(ped) {
    this.sincronismoService.DownloadPedido(ped.pedidoId).subscribe(p => {
      FileSaver.saveAs(p, "Pedido_" + Helper.pad(ped.nrPedido, 6) + "_" + ped.usuario.nome + ".csv");
    })
  }

  public NavToProduto() {
    this.router.navigate(['/produto']);
  }

  public NavToUsuario() {
    this.router.navigate(['/usuario']);
  }

  public NavToVendedor() {
    this.router.navigate(['/vendedor']);
  }

  public NavToMarketing() {
    this.router.navigate(['/marketing']);
  }
  public NavToEstadoCidade() {
    this.router.navigate(['/estado-cidade']);
  }

  public AbrirTesteEmail() {
    this.mostraTesteEmail = true;
    this.carregandoConfiguracaoEmail = true;
    this.configuracaoEmailErro = null;
    this.testeEmail.provedor = '';

    this.sincronismoService.ObterConfiguracaoEmailAtual().subscribe(
      configuracao => {
        this.testeEmail.provedor = configuracao && configuracao.provedor ? configuracao.provedor : '';
        this.testeEmail.emailOrigem = configuracao && configuracao.emailOrigem
          ? configuracao.emailOrigem
          : 'contato@facinatus.net';
        this.carregandoConfiguracaoEmail = false;

        if (!this.testeEmail.provedor) {
          this.configuracaoEmailErro = 'Não foi possível identificar o provedor de e-mail atual.';
        }
      },
      erro => {
        this.carregandoConfiguracaoEmail = false;
        this.configuracaoEmailErro = this.ObterMensagemErroEmail(
          erro,
          'Não foi possível consultar a configuração de e-mail.'
        );
      }
    );
  }

  public FecharTesteEmail(that) {
    if (that.enviandoTesteEmail) {
      return;
    }
    that.mostraTesteEmail = false;
    that.configuracaoEmailErro = null;
  }

  public EnviarTesteEmail(formulario: any) {
    if (this.enviandoTesteEmail || this.carregandoConfiguracaoEmail) {
      return;
    }

    if (!formulario || formulario.invalid || !this.testeEmail.provedor) {
      if (formulario) {
        Object.keys(formulario.controls).forEach(campo => formulario.controls[campo].markAsTouched());
      }
      this.msg.Error('Preencha corretamente os campos obrigatórios.');
      return;
    }

    this.enviandoTesteEmail = true;
    this.sincronismoService.TestarEmail({
      emailDestino: this.testeEmail.emailDestino.trim(),
      assunto: this.testeEmail.assunto.trim(),
      mensagem: this.testeEmail.mensagem.trim()
    }).subscribe(
      resultado => {
        this.enviandoTesteEmail = false;
        var provedor = resultado && resultado.provedor ? resultado.provedor : this.testeEmail.provedor;
        this.msg.Sucesso('E-mail de teste enviado pelo provedor ' + provedor + '.');
      },
      erro => {
        this.enviandoTesteEmail = false;
        this.msg.Error(this.ObterMensagemErroEmail(erro, 'Não foi possível enviar o e-mail de teste.'));
      }
    );
  }

  private ObterMensagemErroEmail(erro: any, mensagemPadrao: string): string {
    if (erro && erro.error) {
      if (typeof erro.error === 'string' && erro.error.trim()) {
        return erro.error;
      }
      if (erro.error.mensagem) {
        return erro.error.mensagem;
      }
      if (erro.error.msg) {
        return erro.error.msg;
      }
      if (erro.error.message) {
        return erro.error.message;
      }
    }
    if (erro && erro.status === 401) {
      return 'Acesso não autorizado ao teste de e-mail.';
    }
    return mensagemPadrao;
  }

  pad(num: number, size: number) {
    return Helper.pad(num, size);
  }

  public sendmail(ped) {
    this.sincronismoService.SendMailVendedor(ped.pedidoId, ped.usuarioFK, "facinatus").subscribe(mail => {
      this.msg.Aviso("E-mail enviado");
    });
  }

  public viewHistory(ped) {
    this.historicoClienteCorrente = ped.usuarioFK;
  }

  public CancelarHistorico(that){
    that.historicoClienteCorrente = false;
  }



  onValueChanged(e) {

    this.dataInicio = e.value[0];
    this.dataFim = e.value[1];
  }





  public UploadCliente() {
    if (this.arquivoCli) {
      this.enviando = true;
      this.sincronismoService.UploadCliente(this.arquivoCli).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        }
        else if (event instanceof HttpResponse) {
          this.enviando = false;
        }

      })
    }
  }
  public UploadProduto() {
    if (this.arquivoProd) {
      this.enviando = true;
      this.sincronismoService.UploadProduto(this.arquivoProd).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        }
        else if (event instanceof HttpResponse) {
          this.enviando = false;
        }
      })
    }
  }

  public UploadCidadeEstado() {
    if (this.arquivoCidEst) {
      this.enviando = true;
      this.sincronismoService.UploadCidadeEstado(this.arquivoCidEst).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          this.percentDone = Math.round(100 * event.loaded / event.total);
        }
        else if (event instanceof HttpResponse) {
          this.enviando = false;
        }
      })
    }
  }

  public onSelectImportCli(event: EventTarget) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    let files: FileList = target.files;
    if (files.length) {
      const file = files[0];
      if (file) {
        const formData = new FormData();
        formData.append(file.name, file);
        this.arquivoCli = formData;
      }
    }
  }
  public onSelectImportCidEst(event: EventTarget) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    let files: FileList = target.files;
    if (files.length) {
      const file = files[0];
      if (file) {
        const formData = new FormData();
        formData.append(file.name, file);
        this.arquivoCidEst = formData;
      }
    }
  }

  public onSelectImportProd(event: EventTarget) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    let files: FileList = target.files;
    if (files.length) {
      const file = files[0];
      if (file) {
        const formData = new FormData();
        formData.append(file.name, file);
        this.arquivoProd = formData;
      }
    }
  }

}
